import { max as mathMax, min as mathMin } from "./math.js";
export default function within(min, value, max) {
  return mathMax(min, mathMin(value, max));
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/within.js
// module id = 597
// module chunks = 3